import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ProductCard({ product }) {
  const navigate = useNavigate();

  return (
    <Card 
      onClick={() => navigate(`/product/${product.id}`)}
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        cursor: 'pointer',
        '&:hover': {
          transform: 'scale(1.02)',
          transition: 'transform 0.2s'
        }
      }}
    >
      <Box sx={{ position: 'relative', pt: '100%' }}>
        <CardMedia
          component="img"
          image={product.images?.[0]}
          alt={product.title}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </Box>
      
      <CardContent sx={{ flexGrow: 1, p: 2, bgcolor: 'background.paper' }}>
        <Typography 
          variant="caption" 
          color="text.secondary"
          sx={{ 
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            mb: 1,
            display: 'block'
          }}
        >
          {product.category?.replace('-', ' ')}
        </Typography>

        <Typography 
          variant="h6" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontSize: '1.1rem',
            fontWeight: 500,
            mb: 1,
            height: '2.4em',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}
        >
          {product.title}
        </Typography>

        <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
          {product.price?.toLocaleString('tr-TR')} TL
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ProductCard; 